import { motion } from 'framer-motion';
import styles from './MarketSelection.desktop.module.css';
import type MarketSelectionProperties from '../MarketSelection.properties.ts';
import { useMarketSelectionController } from '../MarketSelection.controller.ts';
import ItemView from '../item/Item.view.tsx';

export default function MarketSelectionDesktopView(props: MarketSelectionProperties) {
  const { handleMarketSelectionChanged, markets } = useMarketSelectionController(props);

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{
        height: props.isMarketSelectionOpen ? '400px' : '0px',
        opacity: props.isMarketSelectionOpen ? 1 : 0,
      }}
      transition={{ duration: 0.5 }}
      className={styles.motionContainer}
    >
      <>
        {markets.map((market, index) => (
          <ItemView
            key={index}
            selectedValue={props.selectedValue}
            market={market}
            onChange={handleMarketSelectionChanged}
          />
        ))}
      </>
    </motion.div>
  );
}
